import { connect } from 'react-redux';

import AnswerItem from 'presentation/components/__demo__/AnswerItem.jsx';
import { updateSelectedAnswer } from 'app/modules/knowledge_base/demo';

export const mapStateToProps = (state, props) => {
  return {
    ...props,
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onMouseDown: selectedAnswerId => {
      dispatch(
        updateSelectedAnswer({
          selectedResultAnswerId: selectedAnswerId,
        })
      );
    },
  };
};

const AnswerItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AnswerItem);

export default AnswerItemContainer;
